module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Fc2pl"))).then(() => parcelRequire('d0iPb'));